module.exports = __webpack_public_path__ + "img/illuoj.cc3b277f.jpg";